import { useQuery } from '@tanstack/react-query';
import { Typography } from '@mui/material';
import { ROUTES, formatJordan, type AppVersion } from '@serb/shared';
import { api } from '../../api/client';
import { KEYS } from '../../api/keys';

/** Which release of the app is running, so you can tell whether a deploy took effect */
export function VersionLine() {
  const { data } = useQuery({ queryKey: KEYS.version, queryFn: () => api.get<AppVersion>(ROUTES.health) });
  if (!data) return null;
  return (
    <Typography variant="body2" color="text.secondary">
      Version {data.commit} · started {formatJordan(data.startedAt)} (Jordan time)
    </Typography>
  );
}
